import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Shared cache for `get-public-settings`.
 * Used by HomepageJobPostings, PricingSection, SEOHead, etc.
 * 30 min staleTime — public settings change rarely.
 */
export function usePublicSettings<T = any>() {
  return useQuery({
    queryKey: ["public-settings"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("get-public-settings");
      if (error) throw error;
      return (data ?? {}) as T;
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
